const buypassPaymentErrorStrings = {
  "insufficient_funds": "Ikke dekning på konto det skal utbetales fra",
  "bank_account_validation_failed": "Oppgitt kontonummer tilhører ikke kravets avsender"
};

export default buypassPaymentErrorStrings;